import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiMail, FiHelpCircle } from "react-icons/fi";

export default function Support() {
  const nav = useNavigate();

  const textLinkStyle = {
    color: "rgba(255,255,255,0.9)",
    textDecoration: "underline",
    textUnderlineOffset: 3,
  };

  const hintStyle = {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: 12,
    padding: 14,
    marginTop: 12,
    marginBottom: 16,
  };

  return (
    <div 
        style={{
                padding: 16,
                maxWidth: 800,
                margin: "0 auto",
                lineHeight: 1.5,

                height: "100%",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
            }}
    >
      {/* Voltar */}
      <button
        onClick={() => nav("/config", { replace: true })}
        style={{
          background: "transparent",
          border: "none",
          color: "rgba(255,255,255,0.85)",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: 0,
          cursor: "pointer",
          marginTop: 6,
          marginBottom: 14,
        }}
      >
        <FiArrowLeft /> Voltar
      </button>

      <h1>Suporte – FinBot</h1>

      <p>
        Este canal é para dúvidas, sugestões e problemas técnicos no uso do FinBot.
        Respondemos o mais rápido possível.
      </p>

      <div style={hintStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FiMail />
          <strong>Contato de suporte</strong>
        </div>
        <p style={{ marginTop: 10, marginBottom: 0 }}>
          📧{" "}
          <a href="mailto:contato@montebrasil.com.br" style={textLinkStyle}>
            suporte@montebrasil.com.br
          </a>
        </p>
        <p style={{ marginTop: 8, marginBottom: 0, color: "rgba(255,255,255,0.75)" }}>
          (Se preferir, use este e-mail também para solicitações de privacidade e conta.)
        </p>
      </div>

      <h2>Antes de enviar sua mensagem</h2>
      <p>
        Para agilizar, inclua estas informações (se aplicável):
      </p>
      <ul>
        <li>Seu e-mail de cadastro no FinBot</li>
        <li>Modelo do iPhone/iPad e versão do iOS</li>
        <li>O que você estava fazendo quando o problema ocorreu</li>
        <li>Uma captura de tela (se possível)</li>
      </ul>

      <h2>Dúvidas comuns</h2>

      <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FiHelpCircle /> O FinBot executa operações ou envia ordens?
      </h3>
      <p>
        Não. O FinBot <strong>não executa operações financeiras</strong>, <strong>não envia ordens</strong>{" "}
        ao mercado e <strong>não acessa contas bancárias</strong>. Ele ajuda a organizar decisões e acompanhar
        informações inseridas pelo usuário.
      </p>

      <h3>Como solicitar exclusão de conta?</h3>
      <p>
        Você pode iniciar a solicitação diretamente pelo app (em <strong>Configurações da Conta</strong>) ou
        pelo e-mail{" "}
        <a href="mailto:contato@montebrasil.com.br" style={textLinkStyle}>
          suporte@montebrasil.com.br
        </a>
        .
      </p>

      <h2>Links</h2>
      <ul>
        <li>
          <a href="/privacidade" style={textLinkStyle}>
            Política de Privacidade
          </a>
        </li>
        <li>
          <a href="/termos" style={textLinkStyle}>
            Termos e Condições
          </a>
        </li>
      </ul>

      <p style={{ marginTop: 18, color: "rgba(255,255,255,0.70)" }}>
        <strong>Nota:</strong> O FinBot não fornece recomendações personalizadas e não garante resultados.
        Resultados passados não garantem resultados futuros.
      </p>
    </div>
  );
}